// AWS Cognito Configuration
// Auto-updated by recreate-stack.bat

export const awsConfig = {
  region: 'ap-southeast-2',
  userPoolId: 'ap-southeast-2_LFRkHDz5D',
  userPoolWebClientId: '50pqprn7k94glnl835omimrenj',
  identityPoolId: 'ap-southeast-2:9da16f61-5693-4ee8-9f6e-36709707e48d',
  apiEndpoint: 'https://iam6m5xrzj.execute-api.ap-southeast-2.amazonaws.com/prod'
};
